import { Injectable, signal } from '@angular/core';
import { AuthAccount, AuthFlowId } from '../models/auth-flow.models';
import { LoginAccountOption, LoginMeta } from '../models/login-v2-api.models';

export interface RegistrationPathFlags {
  onboardingSkipped: boolean;
  phoneSkipped: boolean;
}

function createEmptyAccount(): AuthAccount {
  return {
    attempts: null,
    code: '',
    id: null,
    login: '',
    pvz: 'ПВЗ',
    tel: '',
  };
}

function createRegistrationPath(): RegistrationPathFlags {
  return {
    onboardingSkipped: false,
    phoneSkipped: false,
  };
}

@Injectable({ providedIn: 'root' })
export class AuthSessionStore {
  readonly account = signal<AuthAccount>(createEmptyAccount());
  readonly accounts = signal<LoginAccountOption[]>([]);
  readonly accountData = signal<LoginMeta | null>(null);
  /**
   * Флаг, который указывает, что пользователь новый
   */
  readonly isNewUser = signal(false);
  /**
   * Флаг, который указывает, что загрузка виджета не удалась
   */
  readonly widgetFailedToLoad = signal(false);
  readonly pvzUuid = signal<string | null>(null);
  readonly currDate = signal<Date | null>(null);
  readonly flowId = signal<AuthFlowId>(AuthFlowId.Login);
  readonly pendingPostAuth = signal<{ needUpdate: boolean } | null>(null);
  readonly redirectUrl = signal<string | null>(null);
  readonly pvzEmployeesLoaded = signal(false);
  readonly registrationPath = signal<RegistrationPathFlags>(
    createRegistrationPath(),
  );
  readonly loginSuccessMethod = signal<string | null>(null);

  reset(flowId: AuthFlowId = AuthFlowId.Login): void {
    this.flowId.set(flowId);
    this.account.set(createEmptyAccount());
    this.accounts.set([]);
    this.accountData.set(null);
    this.isNewUser.set(false);
    this.widgetFailedToLoad.set(false);
    this.pvzUuid.set(null);
    this.currDate.set(null);
    this.pendingPostAuth.set(null);
    this.redirectUrl.set(null);
    this.pvzEmployeesLoaded.set(false);
    this.registrationPath.set(createRegistrationPath());
    this.loginSuccessMethod.set(null);
  }

  patchRegistrationPath(patch: Partial<RegistrationPathFlags>): void {
    this.registrationPath.update((current) => ({ ...current, ...patch }));
  }

  patchAccount(patch: Partial<AuthAccount>): void {
    this.account.update((current) => ({ ...current, ...patch }));
  }

  setAccounts(accounts: LoginAccountOption[]): void {
    this.accounts.set(accounts);
  }

  setAccountData(data: LoginMeta | null): void {
    this.accountData.set(data);
  }

  setPvzUuid(uuid: string | null): void {
    this.pvzUuid.set(uuid);
    if (uuid) {
      this.currDate.set(new Date());
    }
  }
}
